import styles from '../styles/home.module.css';
import { Document, Page, Text, View, pdf } from '@react-pdf/renderer';
import { Button } from '@mui/material';

function PdfPreview({ data }) {

  function formatFieldName(fieldName) {
    return fieldName
      .split("_")
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }
  const downloadPdf = async() => {
    const pdfContent = (
      <Document>
        <Page size="A4">
          <View style={{ padding: '20px' }}>
            <Text style={{ fontSize: '24pt', fontWeight: 'bold', textAlign: 'center' }}>Invoice</Text>
            <Text style={{ fontSize: '16pt', textAlign: 'right', marginTop: '40pt' }}>
              Date: {new Date().toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' })}
            </Text>
            <View style={{ marginTop: '40pt' }}>
              {data && Object.entries(data).map(([key, value]) => (
                <View key={key} style={{ marginBottom: '16pt' }}>
                  <Text style={{ fontSize: '14pt', fontWeight: 'bold' }}>
                    {formatFieldName(key)}:
                  </Text>
                  <Text style={{ fontSize: '14pt' }}>
                    {value}
                  </Text>
                </View>
              ))}
            </View>
          </View>
        </Page>
      </Document>

    );

    const blobStream = await pdf(pdfContent).toBlob();
    const url = URL.createObjectURL(blobStream);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'invoice.pdf';
    document.body.appendChild(link); // add link to DOM
    link.click();
    document.body.removeChild(link); // remove link from DOM once download is complete
  };

  return (
    <main className={styles.main}>
      <div className={styles.cloudright}>
      <Document>
  <Page size="A4" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '20px' }}>
    <Text style={{ fontSize: '24pt' }}>Invoice</Text><br />
    <Text style={{ fontSize: '16pt' }}>Date: {new Date().toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' })}</Text>
    {data &&
      Object.entries(data).map(([key, value]) => (
        <div key={key} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <Text style={{ fontSize: '16pt', textAlign: 'center' }}>
            {formatFieldName(key)}: {value}
          </Text>
        </div>
      ))}
  </Page>
</Document>

      </div>
      {Object.keys(data).length > 0 ? (
         <Button
         onClick={downloadPdf}
         variant="contained"
         style={{
           fontSize: '1.2rem',
           padding: '0.6rem 1rem',
           border: '1px solid #30373d',
           background: '#0e1524',
         }}
       >
         Download Invoice
       </Button>
      ) : null}
    </main>
  );
}

export default PdfPreview;
